import { z } from 'zod';

export const StateSchema = z.object({
    source_link_id: z.string(),
    source_path: z.string(),
    source_page_title: z.string(),
});
